import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import VerbHeading from '../../../../shared/components/VerbHeading';
import PaginatedFetch from '../../../../shared/components/PaginatedFetch';
import Image from '../../../../shared/components/Image';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import VerbText from '../../../../shared/components/VerbText';
import { DEFAULT_IMAGE_URLS, SEGMENT_EVENTS } from '../../../../shared/Constants';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

export default class BrowsePathways extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPathways: false,
            currentWidth: window.outerWidth
        };
    }

    static propTypes = {
        pathways: PropTypes.array,
        page: PropTypes.number,
        fetchPathways: PropTypes.func,
        openPathwayDetails: PropTypes.func,
        userPathway: PropTypes.object,
        onClickBack: PropTypes.func,
        hideLoadMore: PropTypes.bool,
        loggedInUserCompany: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        isMobile: PropTypes.bool,
        pathwayOptions: PropTypes.array,
        limit: PropTypes.number
    };

    static contextType = RuntimeContext;

    componentDidMount() {
        const { isMobile } = this.props;
        const { currentWidth } = this.state;

        if (!isMobile && currentWidth > 450) {
            this.setState({ showPathways: true });
        }
    }

    _openPathwayDetails = (pathway) => {
        const { isVerbAdmin, openPathwayDetails, loggedInUserCompany } = this.props;
        return openPathwayDetails(pathway._id);
    };

    _toggleShowPathways = () => {
        this.setState({ showPathways: !this.state.showPathways });
    };

    _createPathwayRows = () => {
        const { pathways, isMobile, userPathway, pathwayOptions = [] } = this.props;
        const pathwayOptionsById = pathwayOptions.map(({ pathwayId }) => pathwayId); // create map to filter out group team pathways

        const pathwayRows = [];
        pathways.forEach((path, idx) => {
            if ((!userPathway || userPathway.pathwayId !== path._id) && !pathwayOptionsById.includes(path._id)) {
                pathwayRows.push(
                    <div
                        className={`row pathway-card ${idx === 0 ? 'first-card' : ''}`}
                        onClick={() => this._openPathwayDetails(path)}
                        key={path._id}
                    >
                        <div className={'col-11'}>
                            <div className={'row-title col-12'}>
                                <VerbHeading defaultMessage={`${path.name}`} className={'path-title'} hNumber={3} />
                            </div>
                            <div
                                className={`row-details col-12 ${
                                    path.name && path.name.length <= 29 ? '' : 'short-subtitle'
                                }`}
                            >
                                {path.subtitle}
                            </div>
                        </div>
                        <div className={'pathway-arrow col-1'}>
                            <span
                                className={cns('fal fa-chevron-right pathway-chevron-right', { 'fa-lg': isMobile })}
                            ></span>
                        </div>
                    </div>
                );
            }
        });
        return pathwayRows;
    };

    _onClickPathwayFeedback = () => {
        const { loggedInUserCompany, isVerbAdmin } = this.props;
        window.open('https://www.surveygizmo.com/s3/5586288/Learning-Pathways-Feedback');
    };

    render() {
        const {
            page,
            fetchPathways,
            userPathway = {},
            onClickBack,
            hideLoadMore = false,
            isMobile,
            pathways,
            limit
        } = this.props;
        const { showPathways } = this.state;
        const rows = this._createPathwayRows();

        const hasCurrentUserPath = !!userPathway._id;
        const allPathwaysComplete = !pathways.length || !rows.length;
        let panelHeadingId = 'CHOOSE_PATHWAY';
        let panelHeadingMessage = 'Choose a Pathway';
        if (allPathwaysComplete) {
            panelHeadingId = 'COMPLETED_ALL_PATHWAYS';
            panelHeadingMessage = 'You’ve completed all pathways!';
        }
        return (
            <div className={isMobile ? 'mobile-browse-pathway-container' : 'browse-pathway-container'}>
                {isMobile ? (
                    <div className={'title-row'}>
                        <VerbButton
                            className={'change-pathway-back-arrow'}
                            fontAwesomeIcon={'fa-chevron-left'}
                            onClick={() => onClickBack('myPathway')}
                        />
                        <VerbHeading
                            messageId={panelHeadingId}
                            defaultMessage={panelHeadingMessage}
                            className={`choose-pathway-title`}
                            hNumber={3}
                        />
                    </div>
                ) : (
                    <div className={'row title-row'}>
                        <VerbHeading
                            messageId={panelHeadingId}
                            defaultMessage={panelHeadingMessage}
                            className={`row choose-pathway-title ${hasCurrentUserPath ? 'col-7' : ''}`}
                            hNumber={3}
                        />
                        {hasCurrentUserPath ? (
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                fontAwesomeIcon={'fa-chevron-left'}
                                className={'col-4 change-pathway-back-arrow'}
                                onClick={() => onClickBack('myPathway')}
                                buttonText={'BACK'}
                            />
                        ) : null}
                    </div>
                )}

                {allPathwaysComplete ? (
                    <>
                        <div className={'row browse-pathway-image pathways-complete'}>
                            <Image src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_IMAGE} className={'pathway-image'} />
                        </div>
                        <div className={'pathway-feedback-text'}>
                            There are no more pathways available for you to take at this time.
                        </div>
                    </>
                ) : (
                    <>
                        <div className={'row browse-pathway-heading'}>
                            <VerbText
                                messageId={'BROWSE_PATHWAY_TEXT'}
                                defaultMessage={
                                    'A pathway will guide your learning through Verb and help you achieve a goal.'
                                }
                            />
                        </div>
                        <div className={'row browse-pathway-image'}>
                            <Image src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_IMAGE} className={'pathway-image'} />
                        </div>
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            trailingFontAwesomeIcon={`fa-angle-down ${showPathways ? 'fa-flip-vertical' : ''}`}
                            onClick={() => this._toggleShowPathways()}
                            className={cns('mobile-browse-show-pathways', { hidden: !isMobile })}
                        >
                            SHOW PATHWAYS
                        </VerbButton>
                        {showPathways && (
                            <>
                                <div className={'row browse-pathway'}>{rows}</div>
                                <div className={'row'}>
                                    {!hideLoadMore && (
                                        <PaginatedFetch
                                            buttonClassName={'col-sm-5 col-6 load-more'}
                                            className={'col-12 load-more-button'}
                                            limit={limit}
                                            page={page}
                                            fetchMoreFunc={fetchPathways}
                                        />
                                    )}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        );
    }
}
